module.exports = __webpack_public_path__ + "img/aliado-u82.a8bbf2bb.png";